import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import {Grid, Row, Col, Brand} from '@mcafee/pegasus'
export default function McAfeeHeader() {
  const location = useLocation();
  const [AuthToggleLink, setAuthToggleLink] = useState('Login');
  const [AuthToggleTitle, setAuthToggleTitle] = useState('ログイン');

  useEffect(() => {
    // Check if we're on page "X" (e.g., /dashboard)
    if (location.pathname === '/DisplaySupportId') {
      // If so, change the link text to "Logout"
      setAuthToggleLink('ログアウト');
      setAuthToggleTitle('ログアウト');
    } else {
      // Otherwise, set it to "Login"
      setAuthToggleLink('ログイン');
      setAuthToggleTitle('ログイン');
    }
  }, [location.pathname]);

  return (
    <Grid className="ma-header-background">
    <Row className="bg-black">
      <Col xs={5} sm={5} md={4} lg={4} className="header-logo-conatainer flex direction-row align-items-center py-32" >
        <Brand className="header-logo-conatainer" />
      </Col>
      <Col xs={3} sm={3} md={4} lg={4}></Col>
      <Col xs={4} sm={4} md={4} lg={4} className="flex direction-row align-items-center justify-content-end">
        <a id="header_menu" title = {AuthToggleTitle} href={process.env.REACT_APP_DOCOMO_LANDING_URL} style={{color: "#006699"}}>{AuthToggleLink}</a>
      </Col>
    </Row>
    </Grid>
  )
}
